// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__GtLAq","errors":"Errors_errors__isdXR"};